import React, { useState, useEffect } from 'react';
import Events from '../../../../../utilities/EventEmitter';
import CustomConfirmationDialog from '../DriverPopUp/common/CustomConfirmationDialog';
import appConstants from '../../../../../appConstants';

const EVENT_TYPES = {
  [appConstants.PICKUP_EVENTS.SHOW_PICKUP_ASSIGNMENT_CONFIRMATION]: {
    title: 'Confirm Pickup Assignment',
    confirmLabel: 'Assign Pickup',
    message:
      'All pickups in the group will be assigned together. To assign only selected ones, ungroup the pickup first.'
  },
  [appConstants.PICKUP_EVENTS.SHOW_PICKUP_UNASSIGNMENT_CONFIRMATION]: {
    title: 'Confirm Pickup Unassignment',
    confirmLabel: 'Unassign Pickup',
    message: 'All pickups in the group will be unassigned together. To unassign only selected ones, ungroup the pickup first.'
  },
  [appConstants.PICKUP_EVENTS.SHOW_PICKUP_REASSIGNMENT_CONFIRMATION]: {
    title: 'Confirm Pickup Reassignment',
    confirmLabel: 'Reassign Pickup',
    message: 'All pickups in the group will be reassigned together. To reassign only selected ones, ungroup the pickup first.'
  }
};

const PickupConfirmationHandler = () => {
  const [eventData, setEventData] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    const handleConfirmation = (eventType) => (data) => {
      setEventData({ ...data, eventType });
      setIsDialogOpen(true);
    };
    
    // Store handlers so we can remove them later
    const handlers = {};
    Object.keys(EVENT_TYPES).forEach((eventType) => {
      handlers[eventType] = handleConfirmation(eventType);
      Events.on(eventType, handlers[eventType]);
    });

    // Cleanup: remove all event listeners when component unmounts
    return () => {
      Object.keys(EVENT_TYPES).forEach((eventType) => {
        Events.off(eventType, handlers[eventType]);
      });
    };
  }, []);

  const handleConfirm = () => {
    setIsDialogOpen(false);
    eventData?.onConfirm?.();
    setEventData(null);
  };

  const handleCancel = () => {
    setIsDialogOpen(false);
    eventData?.onCancel?.();
    setEventData(null);
  };

  if (!isDialogOpen || !eventData) return null;

  const dialogConfig =
    EVENT_TYPES[eventData.eventType] ||
    EVENT_TYPES[appConstants.PICKUP_EVENTS.SHOW_PICKUP_ASSIGNMENT_CONFIRMATION];

  return (
    <CustomConfirmationDialog
      title={dialogConfig.title}
      cancelButtonLabel="Cancel"
      confirmButtonLabel={dialogConfig.confirmLabel}
      onConfirm={handleConfirm}
      onCancel={handleCancel}>
      <div>{dialogConfig.message}</div>
    </CustomConfirmationDialog>
  );
};

export default PickupConfirmationHandler;
